import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { ThemeProvider } from "./context/ThemeContext";
import { LandingPage } from "./pages/LandingPage";
import { InstructorRegister } from "./pages/InstructorRegister";
import { InstructorDashboard } from "./pages/InstructorDashboard";
import { InstructorProfile } from "./pages/InstructorProfile";
import { CourseMaterials } from "./pages/CourseMaterials";
import { AdminLogin } from "./pages/AdminLogin";
import { AdminDashboard } from "./pages/AdminDashboard";
import "./App.css";

const ProtectedRoute = ({ children, userType }) => {
  const token = localStorage.getItem("mms_token");
  const storedUserType = localStorage.getItem("mms_user_type");

  if (!token) {
    return <Navigate to="/" replace />;
  }

  if (userType && storedUserType !== userType) {
    return <Navigate to="/" replace />;
  }

  return children;
};

function App() {
  return (
    <ThemeProvider>
      <div className="App min-h-screen">
        <Toaster 
          position="top-right" 
          toastOptions={{
            className: 'dark:bg-zinc-900/90 dark:border-white/10 dark:text-white bg-white border-slate-200 text-slate-900',
            style: {
              backdropFilter: 'blur(12px)',
            },
          }}
        />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/register" element={<InstructorRegister />} />
            <Route path="/admin-login" element={<AdminLogin />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute userType="instructor">
                  <InstructorDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute userType="instructor">
                  <InstructorProfile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/materials"
              element={
                <ProtectedRoute>
                  <CourseMaterials />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute userType="admin">
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
